import {
  SET_CURRENT_SLIDE_MODE,
  SELECT_NEXT_SLIDE,
  SELECT_PREV_SLIDE,
  SET_CURRENT_ACTIVE_SLIDE,
} from '@/vuex/types'
import Util from '@/util'

// actions
import common from '@/vuex/actions/common'
import currentAccount from '@/vuex/actions/currentAccount'
import currentUser from '@/vuex/actions/currentUser'
import errors from '@/vuex/actions/errors'
import folders from '@/vuex/actions/folders'
import numbers from '@/vuex/actions/numbers'
import indicators from '@/vuex/actions/indicators'
import presentations from '@/vuex/actions/presentations'
import selections from '@/vuex/actions/selections'
import syncLoading from '@/vuex/actions/syncLoading'
import slideActive from '@/vuex/actions/slideActive'
import presentation from '@/vuex/actions/presentation'
import slides from '@/vuex/actions/slides'
import search from '@/vuex/actions/search'
import exportData from '@/vuex/actions/exportData'
import survey from '@/vuex/actions/survey'
import breadcrumbs from '@/vuex/actions/breadcrumbs'
import pricing from '@/vuex/actions/pricing'
import clickedUrl from '@/vuex/actions/clickedUrl'
import modal from '@/vuex/actions/modal'
import hints from '@/vuex/actions/hints'
import googleSlide from '@/vuex/actions/googleSlide'

// configs
import configs from '@/config'
import histories from '@/vuex/actions/histories'

export default {
  ...common,
  ...currentAccount,
  ...currentUser,
  ...errors,
  ...folders,
  ...numbers,
  ...indicators,
  ...presentations,
  ...selections,
  ...syncLoading,
  ...slideActive,
  ...presentation,
  ...slides,
  ...histories,
  ...search,
  ...exportData,
  ...survey,
  ...breadcrumbs,
  ...pricing,
  ...clickedUrl,
  ...modal,
  ...hints,
  ...googleSlide,
  // Config multiple language
  setLang: (context, payload) => {
    context.commit('setLang', payload)
  },
  setPresenterLang: (context, payload) => {
    context.commit('setPresenterLang', payload)
  },
  userAction: () => {},
  routeChangeAction: () => {},
  showToastAction: () => {},
  afterCreateNewPresentationAction: () => {},
  setSyncPresentation: (context, payload) => {
    context.commit('setSyncPresentation', payload)
  },
  setSyncPresentationAction: (context, payload) => {
    context.commit('setSyncPresentation', payload)
  },
  logOutAccountRemoval: () => {
    Util.deleteTokenCookie()
    Util.cleanUserCookies()
    window.location.href = configs.accountRemovalURL
  },

  [SELECT_NEXT_SLIDE]: ({ dispatch, state, getters }) => {
    const nextSlideId = state.presentation.slides[getters.currentSlideIndex + 1].id
    dispatch(SET_CURRENT_ACTIVE_SLIDE, nextSlideId)
  },

  [SELECT_PREV_SLIDE]: ({ dispatch, state, getters }) => {
    const prevSlideId = state.presentation.slides[getters.currentSlideIndex - 1].id
    dispatch(SET_CURRENT_ACTIVE_SLIDE, prevSlideId)
  },

  [SET_CURRENT_ACTIVE_SLIDE]: ({ dispatch, state }, id) => {
    const selectedSlide = state.presentation.slides.find((s) => s.id === id)
    dispatch('setSlideActive', selectedSlide)
  },

  [SET_CURRENT_SLIDE_MODE]: ({ commit }, payload) => {
    commit(SET_CURRENT_SLIDE_MODE, payload)
  },
}
